import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Name of the pageEntities key the row template's elements read from.
// The Feed wraps each row in a provide({ pageEntities: () => ({...parent,
// [feedRowContextName]: rowEntityId }) }) so the picked DC's element
// mixins (StoryTitle's `pageEntities.story`, EventTitle's
// `pageEntities.event`, …) resolve their entity off the row's id.
//
// Defaults to the `rowContextName` declared on the FEED_OPTIONS entry
// for the picked feed (e.g. HomeStories → "story"), so authors only
// override when they're plugging in a custom feed source.
export default class FeedRowContextName extends BaseOption {
  static userInterfaceComponent = {
    label: "Row Context Name",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      placeholder: "story",
    },
  };

  static defaultValue = "";
}
